import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { ISystemNotification } from '../types/interfaces/INotifications';

export async function getNotifications(): Promise<ApiResponse<ISystemNotification[]>> {
  return apiClient.get<ISystemNotification[]>('/notifications');
}

export async function getNotificationCount(): Promise<
  ApiResponse<{ unread: number; total: number }>
> {
  return apiClient.get('/notifications/count');
}

export async function markNotificationAsRead(id: string): Promise<ApiResponse<boolean>> {
  return apiClient.put<boolean>(`/notifications/${id}/read`);
}

export async function markNotificationAsUnread(id: string): Promise<ApiResponse<boolean>> {
  return apiClient.put<boolean>(`/notifications/${id}/unread`);
}

export async function markAllNotificationsAsRead(): Promise<ApiResponse<boolean>> {
  return apiClient.put<boolean>('/notifications/read-all');
}

export async function deleteNotification(id: string): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`/notifications/${id}`);
}

export async function deleteAllNotifications(): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>('/notifications');
}
